import i18n from 'i18next'

/** Get a new date formatted. */
export const newDateFormatted = (days = 0, date?: Date | string): string => {
    const dateToUse = date ? new Date(date) : new Date()

    const [newDate] = new Date(dateToUse.setDate(dateToUse.getDate() + days))
        .toISOString()
        .split('T')

    return newDate
}

export const localeDate = (
    date: Date | string,
    dateStyle: Intl.DateTimeFormatOptions['dateStyle'] = 'short',
): string => {
    return new Date(date).toLocaleDateString(i18n.language, {
        dateStyle,
    })
}

export const localeTime = (
    date: string,
    timeStyle: Intl.DateTimeFormatOptions['timeStyle'] = 'short',
): string => {
    return new Date(date).toLocaleTimeString(i18n.language, { timeStyle })
}

export const localeDateAndTime = (
    date: string,
    dateStyle: Intl.DateTimeFormatOptions['dateStyle'] = 'short',
    timeStyle: Intl.DateTimeFormatOptions['timeStyle'] = 'short',
): string => {
    return new Date(date).toLocaleString(i18n.language, {
        dateStyle,
        timeStyle,
    })
}
